$(document).ready(function(){

  if ( $('body.single-product').length ) {

    var thumbnail = $('.thumbnails a');

    var img = $('.product-image img.wp-post-image');

    var isMobile = function() {
      if ( $(".thumbnails").css("display") == "none" ) return true;
      return false;
    }

    var slick = $('#product-image-container');

    var slickOptions = {
      arrows: false,
      dots: false
    }

    var destroySlickNow = function() {
      if ( slick.hasClass('slick-initialized') ) {
        slick.slick('unslick');
      }
    }

    var destroySlick = throttle(function() {
      destroySlickNow();
    }, 200);

    var initSlick = throttle(function() {
      slick.slick(slickOptions);
    }, 200);

    var destroyZoomNow = function() {
      $('.zoomContainer').remove();
      img.removeData('elevateZoom');
      img.removeData('zoomImage');
    }

    var destroyZoom = throttle(function() {
      destroyZoomNow();
    }, 200);

    var initZoom = throttle(function() {
      destroyZoomNow();
      img.elevateZoom({
        zoomType  : "inner",
        cursor: "cursor",
        responsive: true
      });
    }, 200);

    var handleZoomSlick = function() {
      if ( isMobile() ) {
        destroyZoom();
        initSlick();
      } else {
        destroySlick();
        initZoom();
      }
    }

    $(window).resize(function(){
      handleZoomSlick();
    });
    handleZoomSlick();

    $(thumbnail).removeAttr('href');

    $(thumbnail).on('click', function(event) {
      $(this).siblings('a').removeClass('active');
      $(this).addClass('active');
      $('zoomContainer').remove();
      var dataImageId = $(this).find('img').attr('data-image-id');
      var imageSelector = 'img[data-image-id="' + dataImageId + '"]';
      $('.product-image img').removeClass('active').addClass('disable');
      $('.product-image').find(imageSelector).removeClass('disable').addClass('active')
      .elevateZoom({
        zoomType  : "inner",
        cursor: "cursor"
      });
    });
  }
});